// http://ahrengot.com/tutorials/greensock-javascript-animation

var $circle = $('.pointer--circle'),
    $wrapper = $('.pointer');
    
$wrapper.mousemove(function(e) {
    a = e.clientX;
    b = e.clientY;
    $circle.css({ left: e.clientX, top: e.clientY });
});